import React from "react";
import { MuiBox } from "../box/MuiBox";
import { MuiInfoToolTip } from "../tooltip/infoToolTip/MuiInfoToolTip";
import { MuiTypography } from "../typography/MuiTypography";
import { LabelWithInfoIconWrapper } from "./LabelWithInfoIcon.style";

interface LabelWithInfoIconProps {
  label: string;
  tooltipMessage: string;
  tooltipPlacement?: "top" | "bottom" | "left" | "right";
}

const LabelWithInfoIcon: React.FC<LabelWithInfoIconProps> = ({
  label,
  tooltipMessage,
  tooltipPlacement = "bottom",
}) => {
  return (
    <LabelWithInfoIconWrapper>
      <MuiBox className="label-container">
        <MuiTypography variant="h5">{label}</MuiTypography>
        <MuiInfoToolTip message={tooltipMessage} placement={tooltipPlacement}  />
      </MuiBox>
    </LabelWithInfoIconWrapper>
  );
};

export default LabelWithInfoIcon;
